import { useContext } from 'react';

import { FormControlGroupContext } from './../contexts';

export const useFormControlGroup = () => {
  const context = useContext(FormControlGroupContext);
  return context;
};
